import {
  APICallState,
  MFAActions,
  Selectors,
  useWidgetDispatch,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library';
import {useCallback, useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import {isAbsoluteUrl, redirectWithForwardUrl} from 'utils/utils';

import ErrorPanel from 'components/ErrorPanel';
import OptoutDialogBox from 'components/OptoutDialogBox';
import {useGetForwardUrl} from 'hooks/useGetFowardUrl';
import {useIsOpenWebView} from 'hooks/useIsOpenWebView';
import {useNavigateWithParams} from 'hooks/useNavigateWithParams';

const ConnectedOptoutDialogBox: React.FunctionComponent = () => {
  const dispatch = useWidgetDispatch();
  const navigate = useNavigateWithParams();
  const editOptinState = useWidgetState(Selectors.editOptinStateSelector);
  const [retryInProgress, setRetryInProgress] = useState(false);
  const forwardUrl = useGetForwardUrl() || '';
  const isOpenWebView = useIsOpenWebView();
  const handleOptout = useCallback(() => {
    if (editOptinState === APICallState.ERROR) {
      setRetryInProgress(true);
    }
    dispatch(MFAActions.editOptinStatus(false));
  }, [dispatch, editOptinState]);

  useEffect(() => {
    if (editOptinState !== APICallState.LOADING) {
      setRetryInProgress(false);
    }
  }, [editOptinState]);

  if (editOptinState === APICallState.SUCCESS) {
    if (isOpenWebView) {
      // TODO: what to do on decline if in open web view, possibly message that says close screen
    } else {
      redirectWithForwardUrl(forwardUrl);
    }

    return null;
  }

  if (editOptinState === APICallState.ERROR || retryInProgress) {
    return (
      <ErrorPanel
        onRetryPress={handleOptout}
        onCancelPress={undefined}
        retryInProgress={retryInProgress}
      />
    );
  }

  return (
    <OptoutDialogBox
      onConfirmPress={handleOptout}
      onCancelPress={() => navigate(-1)}
    />
  );
};

export default ConnectedOptoutDialogBox;
